/**
 * サイト共通の SEO メタ情報。
 *
 * `DEFAULT_DESCRIPTION` は、ページ専用の文面を持たないページ（トップ・お知らせ 一覧／詳細・
 * 会員登録 入口／メール認証・パスワード再設定 4 画面）の `useSeoMeta({ description })` が共通で使う。
 * 文面の変更はここだけで済ませる。ページ専用の文面を持つページ（cart・faq など）と、
 * API から値を取る商品詳細は使わない。
 */
export const DEFAULT_DESCRIPTION: string =
  'オリエンタルバイオの公式サイトです。健やかな毎日を支える健康食品や基礎化粧品をご購入いただけます。ラフィーネ-アルファ、エパゴールド、アレルナイトプラス、ビーケア RJなど、お悩みに合わせて各製品をご確認ください。';
